import { publicUploadFile } from 'api/checklistLogApi';
import xeniaApi from 'api/index';

export const generateVideoThumbnail = async (videoUrl, seekTime = 1) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.src = videoUrl;
    video.preload = 'auto';
    video.muted = true;

    video.addEventListener('loadedmetadata', () => {
      const safeSeek = Math.min(seekTime, video.duration - 0.1);
      video.currentTime = safeSeek;
    });

    video.addEventListener('seeked', () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      }

      const dataUrl = canvas.toDataURL('image/png');
      resolve(dataUrl);
    });

    video.addEventListener('error', (e) => {
      reject(new Error('Failed to load video'));
    });
  });
};

export const dataURLtoFile = (dataURL, fileName) => {
  const byteString = atob(dataURL.split(',')[1]);
  const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([arrayBuffer], { type: mimeString });
  const extension = mimeString.split('/')[1];
  return new File([blob], `${fileName}.${extension}`, { type: mimeString });
};

export const handleVideoThumbnail = async (
  videoUrl: string,
  isPublic: boolean,
  log?: any,
  workspaceId?: string,
) => {
  const generatedThumbnail = await generateVideoThumbnail(videoUrl);
  const thumbnailFile = dataURLtoFile(generatedThumbnail, 'thumbnail');

  let thumbnailResponse;
  if (isPublic) {
    thumbnailResponse = await publicUploadFile({
      files: [thumbnailFile],
      templateId: log.ChecklistId,
      workspaceId: workspaceId ?? '',
      logId: log.id,
    });
  } else {
    thumbnailResponse = await xeniaApi.CreateTaskAttchmentFilesApi([
      thumbnailFile,
    ]);
  }
  return thumbnailResponse;
};
